import { AssistantSearchKind, ChatGptAction, ChatGptConfidence, ChatGptIntentChip, ChatGptIntentStage, ChatGptModalTarget } from "../../types/chatgpt/types-chatgpt";
import { CompanyDTO } from "../../models/system/company/company.dto";
import { IdAndDescriptionDTO } from "../general/id-description";
import { Ticket } from "../../models/system/support/ticket-hub/ticket";
import { UserDTO } from "../../models/system/user/user.dto";

export interface AssistantSearchRequestDTO {
  kinds?       : AssistantSearchKind[];
  limitPerKind?: number;
  queryEnc     : string;
}

export interface AssistantSearchSimDTO extends IdAndDescriptionDTO {
  companyID?   : number | null;
  companyName? : string | null;
  status?      : string | null;
  userFullname?: string | null;
  userID?      : number | null;
}

export interface AssistantSearchTruncatedDTO {
  companies    : boolean;
  portalUsers  : boolean;
  sims         : boolean;
  simUsers     : boolean;
  ticketsClosed: boolean;
  ticketsOpen  : boolean;
}

export interface AssistantSearchResultDTO {
  companies    : CompanyDTO[];
  portalUsers  : UserDTO[];
  sims         : AssistantSearchSimDTO[];
  simUsers     : UserDTO[];
  ticketsClosed: Ticket[];
  ticketsOpen  : Ticket[];
  truncated    : AssistantSearchTruncatedDTO;
}

export function AssistantSearchTruncatedDTO_EmptyObject(): AssistantSearchTruncatedDTO {
  return {
    companies    : false,
    portalUsers  : false,
    sims         : false,
    simUsers     : false,
    ticketsClosed: false,
    ticketsOpen  : false
  };
}

export function AssistantSearchResultDTO_EmptyObject(): AssistantSearchResultDTO {
  return {
    companies    : [],
    portalUsers  : [],
    sims         : [],
    simUsers     : [],
    ticketsClosed: [],
    ticketsOpen  : [],
    truncated    : AssistantSearchTruncatedDTO_EmptyObject()
  };
}

export interface ChatGptActionBase {
  label?: string;
}

export interface ChatGptActionCard {
  actions     : ChatGptAction[];
  confidence  : ChatGptConfidence;
  key         : string;
  kind        : ChatGptIntentChip;
  pinned      : boolean;
  previewItems: string[];
  title       : string;
}

export interface ChatGptActionHistoryEntry {
  action?     : ChatGptAction;
  actionLabel?: string;
  id          : string;
  intent      : ChatGptIntentStage;
  prompt      : string;
  timestamp   : string;
}

export interface ChatGptActionLegacy {
  destination?: unknown;
  label?      : unknown;
  modal?      : unknown;
  payload?    : unknown;
  type?       : unknown;
}

export interface ChatGptActionPayload {
  companyId?   : number;
  companyName? : string;
  deviceId?    : number;
  deviceTypeId?: number;
  entityStatus?: string;
  iccid?       : string;
  ticket?      : Ticket;
  ticketId?    : number;
  ticketTitle? : string;
  userEmail?   : string;
  userId?      : number;
  userName?    : string;
}

export interface ChatGptAuditEntry {
  eventType: string;
  timestamp: string;
}

export interface ChatGptExplainabilityStep {
  details  : string;
  step     : string;
  timestamp: string;
}

export interface ChatGptForcedUserIntent {
  userName: string;
  userType: 'any' | 'portal' | 'sim';
}

export interface ChatGptGlobalSearchData {
  closedTickets: Ticket[];
  companies    : CompanyDTO[];
  openTickets  : Ticket[];
  sims         : AssistantSearchSimDTO[];
  truncated    : boolean;
  users        : UserDTO[];
}

export interface ChatGptGlobalSearchResult {
  actions     : ChatGptAction[];
  companyCount: number;
  simCount    : number;
  ticketCount : number;
  truncated   : boolean;
  userCount   : number;
}

export interface ChatGptInsightsEventCount {
  count    : number;
  eventType: string;
}

export interface ChatGptInsightsSummary {
  totalEvents: number;
  topEvents  : ChatGptInsightsEventCount[];
}

export interface ChatGptModalActionHandlers {
  company    : (payload: any) => void;
  download   : (payload: any) => void;
  manage_sim : (payload: any) => void;
  provision  : (payload: any) => void;
  ticket     : (payload: any) => void;
  timeline   : (payload: any) => void;
  upload     : (payload: any) => void;
  user_portal: (payload: any) => void;
  user_sim   : (payload: any) => void;
}

export interface ChatGptNavigateAction extends ChatGptActionBase {
  destination: string;
  payload?   : ChatGptActionPayload;
  type       : 'navigate';
}

export interface ChatGptOpenModalAction extends ChatGptActionBase {
  modal   : ChatGptModalTarget;
  payload?: ChatGptActionPayload;
  type    : 'open_modal';
}

export interface ChatGptResponse {
  actions: ChatGptAction[];
  reply  : string;
}

export interface ChatGptStageStep {
  active   : boolean;
  completed: boolean;
  key      : ChatGptIntentStage;
  label    : string;
}

export interface SureSimSearchResultRow {
  actions: ChatGptAction[];
  key    : string;
  kind   : ChatGptIntentChip;
  meta   : string;
  title  : string;
}
